var map = {
	"./BaseButton.vue": "./src/components/BaseButton.vue",
	"./BaseButtonDownload.vue": "./src/components/BaseButtonDownload.vue",
	"./BaseButtonDownloadGPS.vue": "./src/components/BaseButtonDownloadGPS.vue",
	"./BaseButtonGroup.vue": "./src/components/BaseButtonGroup.vue",
	"./BaseButtonInfo.vue": "./src/components/BaseButtonInfo.vue",
	"./BaseButtonLight.vue": "./src/components/BaseButtonLight.vue",
	"./BaseButtonPrimary.vue": "./src/components/BaseButtonPrimary.vue",
	"./BaseFormInput.vue": "./src/components/BaseFormInput.vue",
	"./BaseFormSection.vue": "./src/components/BaseFormSection.vue",
	"./BaseFormValidation.vue": "./src/components/BaseFormValidation.vue",
	"./BaseInputArea.vue": "./src/components/BaseInputArea.vue",
	"./BaseInputAutocomplete.vue": "./src/components/BaseInputAutocomplete.vue",
	"./BaseInputCheckbox.vue": "./src/components/BaseInputCheckbox.vue",
	"./BaseInputDate.vue": "./src/components/BaseInputDate.vue",
	"./BaseInputFile.vue": "./src/components/BaseInputFile.vue",
	"./BaseInputFilearea.vue": "./src/components/BaseInputFilearea.vue",
	"./BaseInputLocation.vue": "./src/components/BaseInputLocation.vue",
	"./BaseInputMask.vue": "./src/components/BaseInputMask.vue",
	"./BaseInputMultiple.vue": "./src/components/BaseInputMultiple.vue",
	"./BaseInputPassword.vue": "./src/components/BaseInputPassword.vue",
	"./BaseInputRadio.vue": "./src/components/BaseInputRadio.vue",
	"./BaseInputSelect.vue": "./src/components/BaseInputSelect.vue",
	"./BaseInputSwitch.vue": "./src/components/BaseInputSwitch.vue",
	"./BaseInputText.vue": "./src/components/BaseInputText.vue",
	"./BaseInputTextWithIcon.vue": "./src/components/BaseInputTextWithIcon.vue",
	"./BaseInputTime.vue": "./src/components/BaseInputTime.vue",
	"./BaseItemClassification.vue": "./src/components/BaseItemClassification.vue",
	"./BaseItemCompetition.vue": "./src/components/BaseItemCompetition.vue",
	"./BaseItemCompetitionIconPhoto.vue": "./src/components/BaseItemCompetitionIconPhoto.vue",
	"./BaseItemCompetitionPromoted.vue": "./src/components/BaseItemCompetitionPromoted.vue",
	"./BaseItemCompetitionSmall.vue": "./src/components/BaseItemCompetitionSmall.vue",
	"./BaseLinkInput.vue": "./src/components/BaseLinkInput.vue",
	"./BaseMap.vue": "./src/components/BaseMap.vue",
	"./BaseMapMarker.vue": "./src/components/BaseMapMarker.vue",
	"./BaseMapTrack.vue": "./src/components/BaseMapTrack.vue",
	"./BaseNotificationGlobal.vue": "./src/components/BaseNotificationGlobal.vue",
	"./BaseNotificationLocal.vue": "./src/components/BaseNotificationLocal.vue",
	"./BasePhotoSport.vue": "./src/components/BasePhotoSport.vue",
	"./BasePopup.vue": "./src/components/BasePopup.vue",
	"./BaseTable.vue": "./src/components/BaseTable.vue",
	"./BaseTooltip.vue": "./src/components/BaseTooltip.vue",
	"./PanelInputBaseRadio.vue": "./src/components/PanelInputBaseRadio.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components sync Base[\\w-]+\\.vue$";